import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import VueMask from "v-mask";
import * as VueGoogleMaps from "vue2-google-maps";
import VueYoutube from "vue-youtube";
import vco from "v-click-outside";
import ChartNoDataMessage from "@/components/ChartNoDataMessage";

import router from "./router";
import store from "@/state/store";
import i18n from "./i18n";

import "@/assets/scss/app.scss";

import VueDraggable from "vuedraggable";

import { initFirebaseBackend } from "./helpers/firebase/authUtils";

import { configureFakeBackend } from "./helpers/fakebackend/fake-backend";

import axios from "./axios.js";

import Swal from "sweetalert2";
Vue.prototype.$swal = Swal;

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.config.productionTip = false;
Vue.use(VueYoutube);
Vue.use(BootstrapVue);
Vue.use(vco);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
    libraries: "places",
  },
  installComponents: true,
});
Vue.use(VueDraggable);
Vue.component("apexchart", VueApexCharts);

Vue.prototype.$axios = axios;

axios.interceptors.request.use((config) => {
  store.dispatch("loading/show");
  return config;
});

axios.interceptors.response.use(
  (response) => {
    store.dispatch("loading/close");
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    store.dispatch("loading/close");
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 422:
          // eslint-disable-next-line no-case-declarations
          let errorText = "";
          Object.keys(error.response.data.errors).map(function(objectKey) {
            if (errorText === "") {
              errorText = error.response.data.errors[objectKey][0];
            }
          });
          Swal.fire("ناموفق!", errorText, "error");
          break;
        case 400:
          // eslint-disable-next-line no-case-declarations
          Swal.fire("ناموفق!", error.response.data, "error");
          break;
        case 401:
          console.log(error.response);
          // eslint-disable-next-line no-case-declarations
          const fullPath = router.currentRoute.fullPath;
          if (!fullPath.includes("login")) {
            router.replace({
              name: "login",
              query: { redirect: router.currentRoute.fullPath },
            });
          } else if (error.response.config.method != "get") {
            Swal.fire("ناموفق!", error.response.data.error, "error");
          }
          break;
        case 403:
          // router.replace({
          //   path: '/403',
          //   query: { redirect: router.currentRoute.fullPath },
          // })
          break;
        case 404:
          // router.replace({
          //   name: 'Error-404',
          //   query: { type: 'record' },
          // })
          break;
        case 502:
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });
          break;
        case 500:
          Swal.fire("ناموفق", "خطایی در سمت سرور رخ داده است", "error");
          break;
      }
      return Promise.reject(error.response);
    }
  }
);

import {
  ValidationProvider,
  extend,
  localize,
  ValidationObserver,
} from "vee-validate";

import fa from "vee-validate/dist/locale/fa.json";

localize({
  fa,
});
localize("fa");

import {
  required,
  email,
  confirmed,
  min,
  max,
  min_value,
  numeric,
  regex,
  double,
} from "vee-validate/dist/rules";

extend("required", required);
extend("email", email);
extend("confirmed", confirmed);
extend("min", min);
extend("max", max);
extend("min_value", min_value);
extend("numeric", numeric);
extend("regex", regex);
extend("double", double);

extend("arrayMinLength", {
  params: ["target"],
  validate(value, { target }) {
    return value.length >= target;
  },
  message(field, { target }) {
    return `${field} حداقل باید ${target} عدد باشد`;
  },
});

extend("url", {
  params: ["target"],
  validate(value) {
    const urlPattern = new RegExp(/^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/gm);
    return value.match(urlPattern);
  },
  message(field) {
    return `${field} باید یک آدرس اینترنتی معتبر باشد.`;
  },
});

extend("phone", {
  params: ["target"],
  validate(value) {
    const pattern = new RegExp(/^0[0-9]{2,}[0-9]{7,}$/);
    return value.match(pattern);
  },
  message(field) {
    return `${field} باید یک تلفن ثابت معتبر باشد`;
  },
});

extend("after_or_equal", {
  params: ["targetField", "targetValue"],
  validate(value, { targetValue }) {
    if (value === "") return true;
    let finalValue = value;
    if (typeof finalValue === "string") {
      if (finalValue.includes("/")) {
        finalValue = finalValue.replace("/", "");
      }
      finalValue = parseInt(finalValue);
    } else if (typeof finalValue === "object" && value.id) {
      finalValue = parseInt(value.id);
    }
    let finalTarget = targetValue;
    if (typeof finalTarget === "string") {
      finalTarget = parseInt(finalTarget);
    }
    return finalValue >= finalTarget;
  },
  message: "{_field_} باید بزرگتر یا مساوی با {targetField} باشد",
});

extend("enu", {
  params: ["target"],
  validate(value) {
    const pattern = new RegExp(/^[A-Za-z0-9_]+$/);
    return value.match(pattern);
  },
  message(field) {
    return `${field} تنها می تواند شامل حروف انگلیسی، اعداد و underline باشد`;
  },
});

extend("enuStart", {
  params: ["target"],
  validate(value) {
    const pattern = new RegExp(/^[A-Za-z][A-Za-z0-9]*(?:_[A-Za-z0-9]+)*$/);
    return value.match(pattern);
  },
  message(field) {
    return `${field} تنها می تواند با حروف انگلیسی شروع شده و شامل حروف انگلیسی، اعداد و underline باشد`;
  },
});

extend("mobile", {
  params: ["target"],
  validate(value) {
    const pattern = new RegExp(
      /^09(1[0-9]|3[1-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}$/
    );
    return value.match(pattern);
  },
  message(field) {
    return `${field} باید یک تلفن موبایل معتبر باشد`;
  },
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ChartNoDataMessage", ChartNoDataMessage);

Vue.directive("permission", {
  bind(el, binding) {
    if (
      binding.value != undefined &&
      store.state.auth.user.is_admin == true &&
      !store.state.auth.user.permissions.includes(binding.value)
    ) {
      console.log("sd");
      el.style.display = "none";
    }
  },
});

Vue.directive("role", {
  bind(el, binding) {
    if (
      binding.value != undefined &&
      !store.state.auth.user.roles.includes(binding.value)
    ) {
      el.style.display = "none";
    }
  },
});

Vue.directive("autocomplete", {
  bind(el) {
    el.setAttribute("readonly", "readonly");
    setTimeout(() => {
      el.removeAttribute("readonly");
    }, 1000);
  },
});

import CKEditor from "ckeditor4-vue";

Vue.use(CKEditor);

import ValidationInput from "./components/ValidationFormInputs/ValidationInput.vue";
import ValidationSelect from "./components/ValidationFormInputs/ValidationSelect.vue";
import ValidationTextArea from "./components/ValidationFormInputs/ValidationTextArea.vue";
import Error404 from "./views/pages/utility/error-404.vue";
import ValidationFileUpload from "@/components/ValidationFormInputs/ValidationFileUpload";
import ValidationImageCropperUpload from "@/components/ValidationFormInputs/ValidationImageCropperUpload";
import TableActionButtons from "@/components/table/table-action-buttons";
import Multiselect from "vue-multiselect";
import CrudTable from "@/components/CrudTable/CrudTable.vue";
import Switches from "vue-switches";
import { ToggleButton } from "vue-js-toggle-button";

import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";

Vue.component("ValidationInput", ValidationInput);
Vue.component("ValidationSelect", ValidationSelect);
Vue.component("ValidationTextArea", ValidationTextArea);
Vue.component("Error404", Error404);
Vue.component("ValidationFileUpload", ValidationFileUpload);
Vue.component("ValidationImageCropperUpload", ValidationImageCropperUpload);
Vue.component("TableActionButtons", TableActionButtons);
Vue.component("Multiselect", Multiselect);
Vue.component("CrudTable", CrudTable);
Vue.component("Switches", Switches);
Vue.component("ToggleButton", ToggleButton);
Vue.component("Layout", Layout);
Vue.component("PageHeader", PageHeader);

import { helper } from "./helpers/helper.js";

Vue.prototype.$helper = helper;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
